import { useAuthStore } from '../stores/auth'

import { useUserStore } from '@stores/user.js'
export default async () => {
  const authStore = useAuthStore()
  const userStore = useUserStore()
  const updateUser = authStore.isLogged && !authStore.user
  if (updateUser) {
    const data = await authStore.current()
    if (data.current_language !== authStore.currentLocale) {
      await userStore.editUser({ current_language: authStore.currentLocale })
    }
    if (!authStore.user || !authStore.user.first_name) {
      return { name: 'login' }
    }
  }
  return authStore.isLogged ? true : { name: 'login' }
}
